// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { resolveSupabaseConfig } from './config';
import type { Database } from './types';

const { url: SUPABASE_URL, key: SUPABASE_PUBLISHABLE_KEY } = resolveSupabaseConfig(
  import.meta.env,
  typeof document === 'undefined' ? undefined : document,
);

const authLock =
  typeof navigator !== 'undefined' && 'locks' in navigator
    ? async <T>(name: string, _acquireTimeout: number, fn: () => Promise<T>) =>
        navigator.locks.request(name, { mode: 'exclusive' }, async () => fn())
    : undefined;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    lock: authLock,
  }
});
